import React, { useEffect, useState, useImperativeHandle, forwardRef } from 'react';
import { TextField, Box, Typography } from '@mui/material';
import { IconPlus } from '../../../../utils/icons';

interface Props {
  text?: string;
  label: string;
  onTextChange: (keyPoint: string) => void;
  onAddToPending?: (keyPoint: string) => void;
  isEditMode?: boolean;
}

export const SingleInput = forwardRef<{ getCurrentValue: () => string; clear: () => void }, Props>(
  ({ text, label, onTextChange, onAddToPending, isEditMode = false }, ref) => {
    const [tempText, setTempText] = useState('');

    useImperativeHandle(ref, () => ({
      getCurrentValue: () => tempText.trim(),
      clear: () => setTempText('')
    }));

    const handleAdd = () => {
      const trimmedText = tempText.trim();
      if (trimmedText) {
        if (isEditMode) {
          onTextChange(trimmedText);
        } else if (onAddToPending) {
          onAddToPending(trimmedText);
          setTempText('');
        } else {
          onTextChange(trimmedText);
          setTempText('');
        }
      }
    };

    const handleKeyPress = (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' && !isEditMode && onAddToPending) {
        e.preventDefault();
        handleAdd();
      }
    };

    useEffect(() => {
      setTempText(text || '');
    }, [text]);

    return (
      <Box className="flex gap-2 flex-col items-center w-full p-3 sm:p-4 border border-border-token rounded-lg" style={{ marginBottom: '20px' }}>
        <Typography className="text-text-1 w-full">
          {text ? 'Update' : label}
        </Typography>

        <Box className="flex gap-2 items-center justify-between w-full min-w-0">
          <TextField
            size="small"
            value={tempText}
            onChange={(e) => setTempText(e.target.value)}
            onKeyPress={handleKeyPress}
            className="bg-surface-2 rounded-xl w-full min-w-0"
            placeholder="Add here..."
            sx={{
              '& fieldset': { border: 'none' },
              '& .Mui-focused': {
                border: '1px solid var(--accent)',
                backgroundColor: 'var(--surface)',
              },
            }}
            InputProps={{
              className:
                'border border-transparent hover:border-text-2 w-full',
            }}
          />

          <Box className="flex gap-2 items-center shrink-0">
            <Box
              className="flex items-center justify-center bg-accent rounded-lg cursor-pointer hover:bg-[#8e682c]"
              onClick={handleAdd}
            >
              <IconPlus stroke="#fff" width={36} height={36} />
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }
);
